import React, { useEffect, useRef, useLayoutEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import { withRouter } from 'react-router-dom';
import InvestorInvestManageBannerSC, {
  /*   HintSC, */
  ExtendendWrapSC,
  TooltipSC,
} from './investor-invest-manage-banner.styled';
import { HeadingTwo, BodyText, HeadingOne } from '../typography';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import BiggerText from '../typography/bigger-text';
import { useState } from 'react';
import Button from '../ui/button';
import Slider from '../ui/slider/slider';
import InlineLoading from '../ui/inline-loading/inline-loading';
import numeral from 'numeral';
import WishmakerModal from '../ui/modal/modal';
import SuccessModal from '../success-modal';
import DepositModal from '../investor-investment-detail-banner/deposit-modal';
import SmsVerification from '../sms-verification';
import FreeSourcesForm from '../investor-requests-content/free-sources-form';
import SmallText from '../typography/small-text';

const switchTypes = [
  {
    id: 1,
    type: 'overview',
    label: 'investor_invest_manage_overview',
  },
  {
    id: 2,
    type: 'deposit',
    label: 'investor_invest_manage_deposit',
  },
  {
    id: 3,
    type: 'withdrawal',
    label: 'investor_invest_manage_withdrawal',
  },
  {
    id: 4,
    type: 'change',
    label: 'investor_invest_manage_change',
  },
];

const overviewItems = [
  { key: 'free', label: 'investor_invest_manage_overview_free' },
  { key: 'installments', label: 'investor_invest_manage_overview_installments' },
  { key: 'reserved', label: 'investor_invest_manage_overview_reserved' },
  { key: 'invested', label: 'investor_invest_manage_overview_invested' },
  {
    key: 'free_from_installments',
    label: 'investor_invest_manage_overview_free_from_installments',
    class: 'hoverable',
    type: 'withdrawal1',
  },
  {
    key: 'free_from_deposits',
    label: 'investor_invest_manage_overview_free_from_deposits',
    class: 'hoverable',
    type: 'withdrawal2',
  },
  { key: 'withdrawn', label: 'investor_invest_manage_overview_withdrawn' },
];

const _InvestorInvestManageBanner = ({
  sendInvestorInstruction,
  sendSms,
  instruction,
  createRequest,
  match,
  history,
  location,
  getUserResourcesRequest,
  resourcesOverview,
}) => {
  const [investAmount, setInvestAmount] = useState('');
  const [maxInvestment, setMaxInvestment] = useState(50);
  const [reinvestPercentage, setReinvestPercentage] = useState(100);
  const [isReinvestChecked, setIsReinvestChecked] = useState(true);
  // const [maxInvestmentSmall, setMaxInvestmentSmall] = useState(false);
  // const [maxInvestmentBig, setMaxInvestmentBig] = useState(false);
  const [isSameValues, setIsSameValues] = useState(false);

  const [additionalData, setAdditionalData] = useState({});
  const [isSmsModalOpened, setSmsModalOpened] = useState(false);
  const [isSuccessModalOpened, setSuccessModalOpened] = useState(false);
  const [isSmsCodeError, setIsSmsCodeError] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const [isRequestModalOpened, setIsRequestModalOpened] = useState(false);
  const [isSuccessRequestModalOpened, setIsSuccessRequestModalOpened] = useState(false);
  const [isRequestDepositModalOpened, setisRequestDepositModalOpened] = useState(false);

  const [initialTabOpen, setInitialTabOpen] = useState(undefined);

  const amountInput = useRef(null);

  const [selectedType, setSelectedType] = useState(match.params.tab || 'overview');
  const [isConditionAccepted, setIsConditionAccepted] = useState(false);

  const changeInvestAmount = (amount) => {
    const regex = RegExp('^[0-9]*(?:,[0-9]*)?$');
    if (regex.test(amount) && Number(amount.replace(/,/g, '.')) <= 99999999.99) {
      setInvestAmount(amount);
    } else {
      return;
    }
  };

  useEffect(() => {
    const formattedInvestAmount = Number(investAmount.replace(/,/g, '.'));

    if (
      selectedType === 'change' &&
      maxInvestment === Number(instruction.maxInvestment) &&
      ((reinvestPercentage === Number(instruction.reinvestRate) &&
        instruction.reinvestRate !== null &&
        isReinvestChecked) ||
        (reinvestPercentage !== Number(instruction.reinvestRate) &&
          instruction.reinvestRate === null &&
          !isReinvestChecked))
    ) {
      setIsSameValues(true);
    } else if (
      selectedType === 'deposit' &&
      (formattedInvestAmount === 0 || formattedInvestAmount < 50)
    ) {
      setIsSameValues(true);
    } else {
      setIsSameValues(false);
    }
  }, [
    instruction,
    maxInvestment,
    reinvestPercentage,
    isReinvestChecked,
    selectedType,
    investAmount,
  ]);

  useEffect(() => {
    if (instruction) {
      setInvestAmount('');

      instruction.maxInvestment
        ? setMaxInvestment(Number(instruction.maxInvestment))
        : setMaxInvestment(50);

      instruction.reinvestRate
        ? setReinvestPercentage(instruction.reinvestRate)
        : setReinvestPercentage(100);

      instruction.reinvestRate === null ? setIsReinvestChecked(false) : setIsReinvestChecked(true);
    }
  }, [instruction, selectedType]);

  useLayoutEffect(() => {
    if (amountInput.current && selectedType === 'deposit') {
      amountInput.current.focus();
    }
  }, [amountInput, selectedType]);

  const onSelectedTypeChange = useCallback(
    (type) => {
      setSelectedType(type);
      setIsConditionAccepted(false);
      history.push(`/invest-manage/${type}`);
    },
    [history]
  );

  useEffect(() => {
    if (isRequestModalOpened || selectedType === "overview") {
      getUserResourcesRequest();
    }
  }, [getUserResourcesRequest, isRequestModalOpened, selectedType]);

  useEffect(() => {
    if (match.params.tab && match.params.tab !== selectedType) {
      onSelectedTypeChange(match.params.tab);
    }
  }, [match.params.tab, onSelectedTypeChange, selectedType]);

  const onOuterClick = () => {
    let newMaxInvest = Math.round(maxInvestment / 10) * 10;

    if (Number(newMaxInvest) < 50) {
      setMaxInvestment(50);
    } else if (Number(newMaxInvest) > 500) {
      setMaxInvestment(500);
    } else {
      setMaxInvestment(newMaxInvest);
    }
  };

  const onInvestAmountOuterClick = () => {
    if (Number(investAmount.replace(',', '.')) < 50 && investAmount !== '') {
      setInvestAmount('50');
    } else {
      return;
    }
  };

  const onWithdrawal = () => {
    setIsRequestModalOpened(true);
  };

  const onWithdrawalOne = () => {
    setInitialTabOpen(2);
    setIsRequestModalOpened(true);
  };

  const onWithdrawalTwo = () => {
    setInitialTabOpen(1);
    setIsRequestModalOpened(true);
  };

  const onDeposit = () => {
    setisRequestDepositModalOpened(true);
  };

  const openDepositOnEnter = (ev) => {
    if (ev.key === 'Enter') {
      setisRequestDepositModalOpened(true);
    }
  };

  /*   useEffect(() => {
    if (Number(maxInvestment) < 50) {
      setMaxInvestmentSmall(true);
    } else {
      setMaxInvestmentSmall(false);
    }

    if (Number(maxInvestment) > 500) {
      setMaxInvestmentBig(true);
    } else {
      setMaxInvestmentBig(false);
    }
  }, [maxInvestment]); */

  const onChangeMaxInvestment = (maxInvest) => {
    const regex = new RegExp('^(?:[1-9]|(?:[1-9][0-9])|(?:[1-4][0-9][0-9])|(?:500))$');
    if (regex.test(maxInvest)) {
      setMaxInvestment(maxInvest);
    } else {
      return;
    }
  };

  const onReinvestCheckClick = (checked) => {
    setIsReinvestChecked(checked);
  };

  const onAcceptCondition = (checked) => {
    setIsConditionAccepted(checked);
  };

  const onCancelClick = () => {
    setInvestAmount('');
    setIsConditionAccepted(false);

    instruction.maxInvestment
      ? setMaxInvestment(Number(instruction.maxInvestment))
      : setMaxInvestment(50);

    instruction.reinvestRate
      ? setReinvestPercentage(Number(instruction.reinvestRate))
      : setReinvestPercentage(100);

    instruction.reinvestRate !== null ? setIsReinvestChecked(true) : setIsReinvestChecked(false);
  };

  /* On save instruction click */
  const onSaveClick = () => {
    const replacedAmount = numeral(investAmount).format('0.00.00');
    const formattedInvestAmount = Number(replacedAmount.replace(',', '.'));
    let formData = {};

    if (selectedType === 'change') {
      if (isReinvestChecked === false) {
        formData = {
          amount: null,
          maxInvestment: maxInvestment,
          reinvestRate: null,
        };
      } else {
        formData = {
          amount: null,
          maxInvestment: maxInvestment,
          reinvestRate: reinvestPercentage,
        };
      }
    } else if (selectedType === 'deposit') {
      if (isReinvestChecked === false) {
        formData = {
          amount: formattedInvestAmount,
          maxInvestment: maxInvestment,
          reinvestRate: null,
        };
      } else {
        formData = {
          amount: formattedInvestAmount,
          maxInvestment: maxInvestment,
          reinvestRate: reinvestPercentage,
        };
      }
    }

    onSmsSend();
    setSmsModalOpened(true);
    setAdditionalData(formData);
  };

  const onRequestModalSubmit = (values) => {
    setAdditionalData({
      type: 'investor_free_sources',
      ...values,
    });
    onSmsSend();
    setIsRequestModalOpened(false);
    setSmsModalOpened(true);
  };

  /* Send sms */
  const onSmsSend = () => {
    if (selectedType === 'withdrawal') {
      sendSms({ type: 'withdrawal' });
    } else if (selectedType === 'deposit') {
      sendSms({ type: 'deposit' });
    } else {
      sendSms({ type: 'investment-instruction' });
    }
  };

  /* SMS Confirmation of save instruction call */
  const onSmsModalSubmit = (smsModalData) => {
    const onError = () => {
      setIsSending(false);
    };

    if (selectedType === 'withdrawal') {
      const onBadSmsCode = () => {
        setIsSending(false);
        setIsSmsCodeError(true);
      };
      const onSuccess = () => {
        setIsSending(false);
        setSmsModalOpened(false);
        setIsSuccessRequestModalOpened(true);
        setAdditionalData({});
      };

      const sendCreatedRequest = async () => {
        await createRequest({
          data: { ...smsModalData },
          onSuccess,
          onBadSmsCode,
          onError,
        });
        setIsSending(true);
      };
      sendCreatedRequest();
    } else {
      const onBadSmsCode = () => {
        setIsSending(false);
        setIsSmsCodeError(true);
      };
      const onSuccess = () => {
        setIsSending(false);
        setSmsModalOpened(false);
        setSuccessModalOpened(true);
        setIsReinvestChecked(true);
        setAdditionalData({});
      };

      const saveInstruction = async () => {
        await sendInvestorInstruction({
          data: { ...smsModalData },
          onSuccess,
          onBadSmsCode,
          onError,
        });
        setIsSending(true);
      };
      saveInstruction();
    }
  };

  /* After success modal close  */
  const onCloseSuccess = () => {
    setSuccessModalOpened(false);
  };

  function getGraphPercentages() {
    if (instruction.interestRates) {
      return isReinvestChecked
        ? `${instruction.interestRates.on}`.replace('.', ',')
        : `${instruction.interestRates.off}`.replace('.', ',');
    }
    return '0';
  }

  if (Object.keys(instruction).length === 0) {
    return (
      <InvestorInvestManageBannerSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </InvestorInvestManageBannerSC>
    );
  }

  // const handleFaqClick = (faqId) => {
  //   history.push(`/faq/detail/${faqId}`);
  // };

  return (
    <>
      <WishmakerModal
        isOpened={isSuccessModalOpened}
        onClose={() => onCloseSuccess()}
        className="special"
        withCross
      >
        <SuccessModal headlineText="modal_success_new_instruction" />
      </WishmakerModal>
      <WishmakerModal
        isOpened={isSmsModalOpened}
        onClose={() => setSmsModalOpened(false)}
        className="special"
        withCross
      >
        <SmsVerification
          onSubmit={(data) => onSmsModalSubmit(data)}
          additionalData={additionalData}
          isError={isSmsCodeError}
          isSending={isSending}
          onResend={() => onSmsSend()}
          onBadSms={() => setIsSmsCodeError(false)}
        />
      </WishmakerModal>

      <WishmakerModal
        className="special"
        withCross
        isOpened={isRequestModalOpened}
        onClose={() => {
          setInitialTabOpen(undefined);
          setIsRequestModalOpened(false);
        }}
      >
        <FreeSourcesForm
          resourcesOverview={resourcesOverview}
          onSubmitForm={(values) => onRequestModalSubmit(values)}
          initialTabOpen={initialTabOpen}
        />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isSuccessRequestModalOpened}
        onClose={() => setIsSuccessRequestModalOpened(false)}
        className="special"
        withCross
      >
        <SuccessModal headlineText="investor_invest_manage_invest_table_withdrawal_success" />
      </WishmakerModal>

      <WishmakerModal
        isOpened={isRequestDepositModalOpened}
        onClose={() => setisRequestDepositModalOpened(false)}
        className="special"
        withCross
      >
        <>
          <DepositModal
            onChange={(e) => changeInvestAmount(e.target.value)}
            depositModalData={investAmount}
          />
        </>
      </WishmakerModal>

      <InvestorInvestManageBannerSC>
        <div className="type-switch-wrap">
          <div className="inside-wrap full-width">
            {switchTypes.map((type) => {
              return (
                <button
                  onClick={() => onSelectedTypeChange(type.type)}
                  key={type.id}
                  className={type.type === selectedType ? 'active' : ''}
                >
                  <FormattedMessage id={type.label} defaultMessage={dlt[`${type.label}`]} />
                </button>
              );
            })}
          </div>
        </div>

        {(selectedType === 'change' || selectedType === 'deposit') && (
          <>
            <div className="left-wrap text-justify">
              <HeadingOne className="white">
                {selectedType === 'deposit' ? (
                  <FormattedHTMLMessage
                    id="investor_invest_manage_headline_deposit"
                    defaultMessage={dlt['investor_invest_manage_headline_deposit']}
                  />
                ) : selectedType === 'change' ? (
                  <FormattedHTMLMessage
                    id="investor_invest_manage_headline"
                    defaultMessage={dlt['investor_invest_manage_headline']}
                  />
                ) : null}
              </HeadingOne>
              <BiggerText className="white subtext align-left">
                {selectedType === 'deposit' ? (
                  <>
                    <FormattedHTMLMessage
                      id="investor_invest_manage_subtext_deposit"
                      defaultMessage={dlt['investor_invest_manage_subtext_deposit']}
                    />
                  </>
                ) : selectedType === 'change' ? (
                  <FormattedHTMLMessage
                    id="investor_invest_manage_subtext"
                    defaultMessage={dlt['investor_invest_manage_subtext']}
                  />
                ) : null}
              </BiggerText>
            </div>

            <div className="mid-wrap">
              {selectedType === 'deposit' ? (
                <>
                  <div className="mid-wrap--card">
                    <div className="mid-wrap--card__top">
                      <BodyText className="grey bolder ">
                        <FormattedMessage
                          id="investor_invest_manage_invest_amount"
                          defaultMessage={dlt['investor_invest_manage_invest_amount']}
                        />
                      </BodyText>
                      {/*  <HintSC>?</HintSC> */}
                    </div>
                    <div className="mid-wrap--card__bottom">
                      <div className="wrap">
                        <label htmlFor="investAmount" className="input-label">
                          €
                        </label>
                        <input
                          ref={amountInput}
                          id="investAmount"
                          className="invest-amount-input"
                          type="text"
                          placeholder="1 000,00"
                          value={investAmount}
                          onChange={(e) => changeInvestAmount(e.target.value)}
                          onBlur={() => onInvestAmountOuterClick()}
                          onKeyPress={openDepositOnEnter}
                        />
                      </div>
                    </div>
                  </div>
                  <Button
                    type="PRIMARY"
                    className="focus-button"
                    onClick={() => onDeposit()}
                    disabled={!investAmount}
                  >
                    <FormattedMessage
                      id="investor_invest_manage_btn_deposit"
                      defaultMessage={dlt['investor_invest_manage_btn_deposit']}
                    />
                  </Button>
                </>
              ) : null}
              {selectedType === 'change' ? (
                <div className="mid-wrap--card">
                  <div className="mid-wrap--card__top">
                    <BodyText className="grey bolder">
                      <FormattedMessage
                        id="investor_invest_manage_invest_max"
                        defaultMessage={dlt['investor_invest_manage_invest_max']}
                      />
                    </BodyText>
                    {/*    <HintSC>?</HintSC> */}
                  </div>
                  <div className="mid-wrap--card__bottom">
                    <div className="wrap">
                      <label htmlFor="maxInvest" className="input-label">
                        €
                      </label>
                      <input
                        id="maxInvest"
                        className="invest-amount-input"
                        type="text"
                        placeholder="50"
                        onBlur={() => onOuterClick()}
                        value={maxInvestment}
                        onChange={(e) => onChangeMaxInvestment(e.target.value)}
                      />
                    </div>

                    <Slider
                      className="custom"
                      value={maxInvestment >= 50 ? maxInvestment : 50}
                      onChange={(e) => onChangeMaxInvestment(e)}
                      name="maxInvest"
                      min={50}
                      max={500}
                      step={10}
                      ishandle
                    />
                    <div className="mid-wrap--card__bottom--stats">
                      <BodyText className="white">min: 50 €</BodyText>
                      <BodyText className="white">max: 500 €</BodyText>
                    </div>
                  </div>
                </div>
              ) : null}
              {selectedType === 'change' ? (
                <div className={isReinvestChecked ? 'mid-wrap--card' : 'mid-wrap--card disabled'}>
                  <div
                    className={
                      isReinvestChecked ? 'mid-wrap--card__top' : 'mid-wrap--card__top disabled'
                    }
                  >
                    <BodyText className="grey bolder">
                      <FormattedMessage
                        id="investor_invest_manage_invest_percentage"
                        defaultMessage={dlt['investor_invest_manage_invest_percentage']}
                      />
                    </BodyText>
                    {/*  <HintSC>?</HintSC> */}
                  </div>
                  <div
                    className={
                      isReinvestChecked
                        ? 'mid-wrap--card__bottom padded'
                        : 'mid-wrap--card__bottom padded disabled'
                    }
                  >
                    <Slider
                      value={reinvestPercentage}
                      onChange={(e) => setReinvestPercentage(e)}
                      name="percentage"
                      min={1}
                      max={100}
                      step={1}
                      ishandle
                    />
                    <div className="mid-wrap--card__bottom--stats">
                      <BodyText className="orange">{reinvestPercentage} %</BodyText>
                      <BodyText className="white">100 %</BodyText>
                    </div>
                  </div>
                </div>
              ) : null}
              {/*    <div className="mid-wrap--card">
            <div className="mid-wrap--card__top">
              <BodyText className="grey bolder">
                <FormattedMessage
                  id="investor_invest_manage_rating"
                  defaultMessage={dlt['investor_invest_manage_rating']}
                />
              </BodyText>
              <HintSC>?</HintSC>
            </div>
            <div className="mid-wrap--card__bottom"></div>
          </div> */}

              {selectedType === 'change' ? (
                <div className="reinvest-approve">
                  <input
                    className="check-reinvest"
                    type="checkbox"
                    onChange={(e) => onReinvestCheckClick(e.target.checked)}
                    checked={isReinvestChecked}
                  />
                  <BiggerText className="white">
                    <FormattedMessage
                      id="investor_invest_manage_allow_reinvest"
                      defaultMessage={dlt['investor_invest_manage_allow_reinvest']}
                    />
                  </BiggerText>
                  <TooltipSC
                    contentId="investor_invest_manage_reinvest_tooltip"
                    overlayInnerStyle={{ maxWidth: '335px' }}
                    align={{ offset: [-1, -3] }}
                  />
                </div>
              ) : null}
            </div>

            <div
              className="right-wrap"
              style={{
                paddingTop: selectedType === 'deposit' || selectedType === 'change' ? 42 : 10,
                marginBottom: (selectedType === 'deposit' || selectedType === 'change') && 80,
              }}
            >
              <div className="circle-progress-wrap">
                <CircularProgressbarWithChildren
                  value={100}
                  strokeWidth={1.5}
                  styles={buildStyles({ strokeLinecap: 'round' })}
                >
                  <div className="circle-progress-wrap--text">
                    <div>{getGraphPercentages()}</div>
                    <span>%</span>
                  </div>
                </CircularProgressbarWithChildren>
              </div>

              <div className="interest-wrap">
                <HeadingTwo className="white">
                  <FormattedHTMLMessage
                    id="investor_invest_manage_interest_headline"
                    defaultMessage={dlt['investor_invest_manage_interest_headline']}
                  />
                </HeadingTwo>
                <BodyText className="grey subtext">
                  <FormattedMessage
                    id="investor_invest_manage_interest_subtext"
                    defaultMessage={dlt['investor_invest_manage_interest_subtext']}
                  />
                </BodyText>
              </div>
            </div>
          </>
        )}
        {selectedType === 'withdrawal' && (
          <div className="withdrawal-wrap">
            <HeadingOne className="white">
              <FormattedHTMLMessage
                id="investor_invest_manage_headline_withdrawal"
                defaultMessage={dlt['investor_invest_manage_headline_withdrawal']}
              />
            </HeadingOne>
            <BiggerText className="white subtext">
              <FormattedHTMLMessage
                id="investor_invest_manage_subtext_withdrawal"
                defaultMessage={dlt['investor_invest_manage_subtext_withdrawal']}
              />
            </BiggerText>
            <Button type="PRIMARY" onClick={() => onWithdrawal()}>
              <FormattedMessage
                id="investor_invest_manage_withdrawal_action"
                defaultMessage={dlt['investor_invest_manage_withdrawal_action']}
              />
            </Button>
          </div>
        )}

        {selectedType === 'overview' && (
          <>
            <div className="overview-wrap">
              <div className="mid-wrap">
                <HeadingOne className="white text-center">
                  <FormattedHTMLMessage
                    id="investor_invest_manage_overview"
                    defaultMessage={dlt['investor_invest_manage_overview']}
                  />
                </HeadingOne>
                <BiggerText className="white subtext">
                  <FormattedHTMLMessage
                    id="investor_invest_manage_overview_description"
                    defaultMessage={dlt['investor_invest_manage_overview_description']}
                  />
                </BiggerText>
                {overviewItems.map((item) => (
                  <div
                    className={`mid-wrap--card ${item.class === 'hoverable' ? 'hoverable' : ''}`}
                    onClick={
                      item.type === 'withdrawal1'
                        ? () => onWithdrawalOne()
                        : item.type === 'withdrawal2'
                        ? () => onWithdrawalTwo()
                        : null
                    }
                    key={item.key}
                  >
                    {/* <div
               
               
                  onClick={item.type === selectedType ? () => onWithdrawal() : ''}
                > */}
                    <div className="mid-wrap--card__top">
                      <BodyText className="grey bolder">
                        <FormattedMessage id={item.label} defaultMessage={dlt[item.label]} />
                      </BodyText>
                    </div>
                    <div className="mid-wrap--card__bottom">
                      <div className="wrap">
                        <div className="invest-amount-input">
                          {resourcesOverview[item.key]
                            ? numeral(Number(resourcesOverview[item.key])).format('0.00.00')
                            : '-'}
                        </div>
                        <label htmlFor="investAmount" className="input-label">
                          €
                        </label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* <div className="right-wrap"></div> */}
          </>
        )}
      </InvestorInvestManageBannerSC>
      {selectedType === 'change' && (
        <ExtendendWrapSC
          className={/* maxInvestmentSmall || maxInvestmentBig || */ isSameValues ? '' : 'active'}
        >
          <div className="extended-wrap">
            <div className="text-wrap">
              <BodyText className="grey">
                {selectedType === 'deposit' ? (
                  <FormattedHTMLMessage
                    id="investor_invest_manage_save_hint_deposit"
                    defaultMessage={dlt['investor_invest_manage_save_hint_deposit']}
                  />
                ) : (
                  <FormattedHTMLMessage
                    id="investor_invest_manage_save_hint"
                    defaultMessage={dlt['investor_invest_manage_save_hint']}
                  />
                )}
              </BodyText>
            </div>
            <div className="buttons-wrap">
              <div className="approve-wrap">
                <input
                  className="check-reinvest"
                  type="checkbox"
                  onChange={(e) => onAcceptCondition(e.target.checked)}
                  checked={isConditionAccepted}
                />
                <SmallText className="white">
                  <FormattedHTMLMessage
                    id="investor_invest_manage_condition_label"
                    defaultMessage={dlt['investor_invest_manage_condition_label']}
                    values={{
                      linkVop: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/vseobecne_obchodne_podmienky.pdf`,
                      linkPayments: `${process.env.REACT_APP_WISHMAKER_LANDING_URI}/static/pdf/sadzobnik_poplatkov.pdf`,
                    }}
                  />
                </SmallText>
              </div>
              <Button type="OUTLINED" className="cancel-button" onClick={() => onCancelClick()}>
                <FormattedMessage id="global_cancel" defaultMessage={dlt['global_cancel']} />
              </Button>
              <Button
                type="PRIMARY"
                onClick={() => onSaveClick()}
                disabled={
                  /* maxInvestmentSmall || maxInvestmentBig || */ isSameValues ||
                  !isConditionAccepted
                }
              >
                {selectedType === 'deposit' ? (
                  <FormattedMessage id="global_deposit" defaultMessage={dlt['global_deposit']} />
                ) : (
                  <FormattedMessage id="global_save_new" defaultMessage={dlt['global_save_new']} />
                )}
              </Button>
            </div>
          </div>
        </ExtendendWrapSC>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      sendSms: ActionCreators.sendSms,
      createRequest: ActionCreators.createRequest,
      sendInvestorInstruction: ActionCreators.sendInvestorInstruction,
      getUserResourcesRequest: ActionCreators.getUserResourcesRequest,
    },
    dispatch
  );
};

const mapStateToProps = (state) => ({
  resourcesOverview: state.resourcesOverview,
});

const InvestorInvestManageBanner = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_InvestorInvestManageBanner)
);

export default InvestorInvestManageBanner;
